import * as React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const CaseStudy = ({
  title = "Our <span class='text-primary'>success stories</span>",
  description = "Delivered industry-focused flawless digital products engaging India’s top talent every client desires.",
  sectionClass = 'bg-white',
  category,
  specificTitle
}) => {

  const { allPortfolioJson } = useStaticQuery(graphql`
    query CaseStudyList {
      allPortfolioJson(sort: {date: DESC}) {
      edges {
        node {
          id
          title
          slug
          categories
          tags
          excerpt
          featured {
            childImageSharp {
              gatsbyImageData(width: 540, height: 380)
            }
          }
          details {
            about {
              aboutDescripion
              aboutExpertise {
                expTitle
                expMore
              }
              aboutCategory {
                catTitle
                category
              }
            }
          }          
        }
      }
    }
  }`);

  const allPortfolio = allPortfolioJson.edges;
  return (
    <>
      <section className={`section case-study-section ${sectionClass}`}>

        <Container className="py-5">
          <div className="mb-4 pb-1">
            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="max-width-950 lead">{description}</p>
          </div>
          <Swiper
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            navigation={true}
            pagination={{
              clickable: true,
            }}
            className="work-swiper"
          >

            {
              specificTitle ?
                allPortfolio
                  .filter(portfolio => specificTitle.includes(portfolio.node.title))
                  .map((portfolio, index) => {
                    const imagePortf = getImage(portfolio.node.featured);
                    const aboutDescripion = portfolio.node?.details?.about?.aboutDescripion.substr(0, 150) + '...'
                    if (index < 3) {
                      return (
                        <SwiperSlide key={index}>
                          <div className="card blog-list-card bg-light p-4  p-lg-5 rounded20">
                            <Row className="g-5 align-items-center">
                              <Col lg={6}>
                                <div className="blog-list-content">
                                  <div className="article bg-light">

                                    <p className="text-primary fw-semibold category-single-post">{portfolio.node.categories?.map((category, index) => {
                                      // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                                      return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                                      // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                                    })
                                    }</p>
                                    <h2 className="blog-title font-size-28 mb-3 mt-2">
                                      <Link to={`/case-studies/${portfolio.node.slug}.html`}>
                                        {portfolio.node.title}
                                      </Link>
                                    </h2>
                                    {portfolio.node.excerpt ? <p className="blog-content font-size-16 mb-4">{portfolio.node.excerpt.substr(0, 250)}</p>
                                      : <div className="blog-content font-size-16 mb-4" dangerouslySetInnerHTML={{ __html: aboutDescripion }} />
                                    }
                                    {/* <Row className="mb-2">
                <Col xs={12} sm={4} className="fw-medium">Category</Col>
                <Col xs={12} sm={8} className="category-single-post">
                  {portfolio.node.categories?.map((category, index) => {
                    // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                    return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                    // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                  })
                  }
                </Col>
              </Row> */}
                                    {
                                      (portfolio.node?.details?.about?.aboutExpertise?.expTitle || portfolio.node?.details?.about?.aboutCategory?.catTitle) ?
                                        <ul className="bullet-list">
                                          <li><span className="fw-medium">{portfolio.node?.details?.about?.aboutExpertise?.expTitle}</span> : {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}</li>
                                          <li><span className="fw-medium">{portfolio.node?.details?.about?.aboutCategory?.catTitle}</span> : {portfolio.node?.details?.about?.aboutCategory?.category.join(" , ")}</li>
                                          {/* <li>{portfolio.node?.details?.about?.aboutFacts?.teamTitle} : {portfolio.node?.details?.about?.aboutFacts?.teamNo}</li> */}
                                        </ul>
                                        :
                                        null
                                    }
                                    {/* <Row className="mb-2"> */}
                                    {/* <Col xs={12} sm={4} className="fw-medium">
                  {portfolio.node?.details?.about?.aboutCategory?.catTitle}
                </Col>
                <Col xs={12} sm={8}>
                  {portfolio.node?.details?.about?.aboutCategory?.category}
                </Col> */}
                                    {/* <Col xs={12} sm={4} className="fw-medium">
                  {portfolio.node?.details?.about?.aboutExpertise?.expTitle}
                </Col>
                <Col xs={12} sm={8}>
                  {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}
                </Col> */}
                                    {/* </Row> */}
                                    <div>
                                      <Link to={`/case-studies/${portfolio.node.slug}.html`} className="btn btn-link px-0 mt-3 pb-0">
                                        <span>View full case study</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="work-image text-end">
                                  <GatsbyImage loading="lazy" className="rounded" width={540} height={380} image={getImage(imagePortf)} alt="featured" />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </SwiperSlide>
                      )
                    }
                    else {
                      return null;
                    }
                  }) :
                category ?
                  allPortfolio
                    .filter(edge => edge.node.categories.some(i => category.includes(i)))
                    .map((portfolio, index) => {
                      const imagePortf = getImage(portfolio.node.featured);
                      const aboutDescripion = portfolio.node?.details?.about?.aboutDescripion.substr(0, 150) + '...'
                      if (index < 3) {
                        return (
                          <SwiperSlide key={index}>
                            <div className="card blog-list-card bg-light p-4  p-lg-5 rounded20">
                              <Row className="g-5 align-items-center">
                                <Col lg={6}>
                                  <div className="blog-list-content">
                                    <div className="article bg-light">

                                      <p className="text-primary fw-semibold category-single-post">{portfolio.node.categories?.map((category, index) => {
                                        // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                                        return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                                        // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                                      })
                                      }</p>
                                      <h2 className="blog-title font-size-28 mb-3 mt-2">
                                        <Link to={`/case-studies/${portfolio.node.slug}.html`}>
                                          {portfolio.node.title}
                                        </Link>
                                      </h2>
                                      {portfolio.node.excerpt ? <p className="blog-content font-size-16 mb-4">{portfolio.node.excerpt.substr(0, 250)}</p>
                                        : <div className="blog-content font-size-16 mb-4" dangerouslySetInnerHTML={{ __html: aboutDescripion }} />
                                      }
                                      {/* <Row className="mb-2">
                                  <Col xs={12} sm={4} className="fw-medium">Category</Col>
                                  <Col xs={12} sm={8} className="category-single-post">
                                    {portfolio.node.categories?.map((category, index) => {
                                      // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                                      return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                                      // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                                    })
                                    }
                                  </Col>
                                </Row> */}
                                      {
                                        (portfolio.node?.details?.about?.aboutExpertise?.expTitle || portfolio.node?.details?.about?.aboutCategory?.catTitle) ?
                                          <ul className="bullet-list">
                                            <li><span className="fw-medium"> {portfolio.node?.details?.about?.aboutExpertise?.expTitle}</span> : {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}</li>
                                            <li><span className="fw-medium">{portfolio.node?.details?.about?.aboutCategory?.catTitle}</span> : {portfolio.node?.details?.about?.aboutCategory?.category.join(" , ")}</li>
                                            {/* <li>{portfolio.node?.details?.about?.aboutFacts?.teamTitle} : {portfolio.node?.details?.about?.aboutFacts?.teamNo}</li> */}
                                          </ul>
                                          :
                                          null
                                      }
                                      {/* <Row className="mb-2"> */}
                                      {/* <Col xs={12} sm={4} className="fw-medium">
                                    {portfolio.node?.details?.about?.aboutCategory?.catTitle}
                                  </Col>
                                  <Col xs={12} sm={8}>
                                    {portfolio.node?.details?.about?.aboutCategory?.category}
                                  </Col> */}
                                      {/* <Col xs={12} sm={4} className="fw-medium">
                                    {portfolio.node?.details?.about?.aboutExpertise?.expTitle}
                                  </Col>
                                  <Col xs={12} sm={8}>
                                    {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}
                                  </Col> */}
                                      {/* </Row> */}
                                      <div>
                                        <Link to={`/case-studies/${portfolio.node.slug}.html`} className="btn btn-link px-0 mt-3 pb-0">
                                          <span>View full case study</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="work-image text-end">
                                    <GatsbyImage loading="lazy" className="rounded" width={540} height={380} image={getImage(imagePortf)} alt="featured" />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </SwiperSlide>
                        )
                      }
                      else {
                        return null;
                      }
                    })
                  :
                  allPortfolio.map((portfolio, index) => {

                    const imagePortf = getImage(portfolio.node.featured);
                    const aboutDescripion = portfolio.node?.details?.about?.aboutDescripion.substr(0, 150) + '...';

                    if (index < 3) {
                      return (
                        <SwiperSlide key={index}>
                          <div className="card blog-list-card bg-light p-4  p-lg-5 rounded20">
                            <Row className="g-5 align-items-center">
                              <Col lg={6}>
                                <div className="blog-list-content">
                                  <div className="article bg-light">

                                    <p className="text-primary fw-semibold category-single-post">{portfolio.node.categories?.map((category, index) => {
                                      // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                                      return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                                      // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                                    })
                                    }</p>
                                    <h2 className="blog-title font-size-28 mb-3 mt-2">
                                      <Link to={`/case-studies/${portfolio.node.slug}.html`}>
                                        {portfolio.node.title}
                                      </Link>
                                    </h2>
                                    {portfolio.node.excerpt ? <p className="blog-content font-size-16 mb-4">{portfolio.node.excerpt.substr(0, 250)}</p>
                                      : <div className="blog-content font-size-16 mb-4" dangerouslySetInnerHTML={{ __html: aboutDescripion }} />
                                    }
                                    {/* <Row className="mb-2">
                                    <Col xs={12} sm={4} className="fw-medium">Category</Col>
                                    <Col xs={12} sm={8} className="category-single-post">
                                      {portfolio.node.categories?.map((category, index) => {
                                        // const catUrl = category.toLowerCase().replace(/\W+/g, '-');
                                        return (<span key={index} className="category">{category} <i className="coma-sep"> , </i></span>)
                                        // return (<Link key={category} to={`/portfolio-category/${catUrl}`} rel="category tag" className="category force-hover">{category} <i className="coma-sep"> , </i></Link>)
                                      })
                                      }
                                    </Col>
                                  </Row> */}
                                    {
                                      (portfolio.node?.details?.about?.aboutExpertise?.expTitle || portfolio.node?.details?.about?.aboutCategory?.catTitle) ?
                                        <ul className="bullet-list">
                                          <li><span className="fw-medium"> {portfolio.node?.details?.about?.aboutExpertise?.expTitle}</span> : {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}</li>
                                          <li><span className="fw-medium">{portfolio.node?.details?.about?.aboutCategory?.catTitle}</span> : {portfolio.node?.details?.about?.aboutCategory?.category.join(" , ")}</li>
                                          {/* <li>{portfolio.node?.details?.about?.aboutFacts?.teamTitle} : {portfolio.node?.details?.about?.aboutFacts?.teamNo}</li> */}
                                        </ul>
                                        :
                                        null
                                    }
                                    {/* <Row className="mb-2"> */}
                                    {/* <Col xs={12} sm={4} className="fw-medium">
                                      {portfolio.node?.details?.about?.aboutCategory?.catTitle}
                                    </Col>
                                    <Col xs={12} sm={8}>
                                      {portfolio.node?.details?.about?.aboutCategory?.category}
                                    </Col> */}
                                    {/* <Col xs={12} sm={4} className="fw-medium">
                                      {portfolio.node?.details?.about?.aboutExpertise?.expTitle}
                                    </Col>
                                    <Col xs={12} sm={8}>
                                      {portfolio.node?.details?.about?.aboutExpertise?.expMore.join(" , ")}
                                    </Col> */}
                                    {/* </Row> */}
                                    <div>
                                      <Link to={`/case-studies/${portfolio.node.slug}.html`} className="btn btn-link px-0 mt-3 pb-0">
                                        <span>View full case study</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="work-image text-end">
                                  <GatsbyImage loading="lazy" className="rounded" width={540} height={380} image={getImage(imagePortf)} alt="featured" />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </SwiperSlide>
                      )
                    }
                    else {
                      return null;
                    }
                  })
            }
          </Swiper>
          {/* <div className="text-center mt-5 pt-5">
            <Link to="/works.html" className="btn btn-link">
              <span>View more case studies</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
            </Link>
          </div> */}
        </Container>
      </section >
    </>
  )

}

export default CaseStudy;
